import $ from 'jquery';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/button';
import 'bootstrap/js/dist/tooltip';
import { DateTime } from 'luxon';

const $document = $(document);
const $window = $(window);

const params = new URLSearchParams(window.location.search);
const $header = $('.site-header-wrap');
const $form = $('.wpbs-main-wrapper-form-1');
const $search = $('.wpbs_s-search-widget-form');
const $calendar = $form.find('.wpbs-container');
const date_regex = /(\d{4})-(\d{1,2})-(\d{1,2})/;

if ($form.length) {
    let $field_total, $form_fields, $extras;

    $window.on('wpbs_pricing_table_updated', setup_form);
    $document.on('wpbs_form_updated', setup_form);
    setup_form();

    function setup_form() {
        $form.find('[data-toggle="tooltip"]').tooltip();
        $field_total = $form.find('.wpbs-form-field-total');
        $form_fields = $form.find('.wpbs-form-fields');
        $extras = $form.find('[name="wpbs-input-1-3[]"]');
    }

    const arrival = date_regex.exec(params.get('wpbs-search-start-date'));
    const departure = date_regex.exec(params.get('wpbs-search-end-date'));
    if (arrival && departure) {
        const arrival_date = DateTime.local(+arrival[1], +arrival[2], +arrival[3], {zone: "utc"}).toJSDate();
        const departure_date = DateTime.local(+departure[1], +departure[2], +departure[3], {zone: "utc"}).toJSDate();
        if (arrival_date > new Date) {
            $calendar.data('start_date', arrival_date.getTime());
            $calendar.data('end_date', departure_date.getTime());
            $calendar.addClass('wpbs-dates-selected');
            $document.trigger('wpbs_dates_selected', [$calendar.data('id')]);
        }
    }

    $document.on('wpbs_dates_selected wpbs_form_updated', (e, [calendar]) => {
        calendar.querySelector('form').scrollIntoView();
        const checkin = $extras.filter((i, el) => el.value.startsWith('Early check-in')).get(0);
        if (checkin) {
            if (calendar.querySelector('.wpbs-selected-first.wpbs-legend-item-4')) {
                checkin.checked = false;
                checkin.disabled = true;
                checkin.parentElement.style.display = 'none';
            } else {
                checkin.disabled = false;
                checkin.parentElement.style.display = '';
            }
        }
        const checkout = $extras.filter((i, el) => el.value.startsWith('Late check-out')).get(0);
        if (checkout) {
            if (calendar.querySelector('.wpbs-selected-last.wpbs-legend-item-3')) {
                checkout.checked = false;
                checkout.disabled = true;
                checkout.parentElement.style.display = 'none';
            } else {
                checkout.disabled = false;
                checkout.parentElement.style.display = '';
            }
        }
    });

    //book now total scroll with form
    $window.on('load scroll resize', () => {
        if ($window.outerWidth() > 1000) {
            const form_field_total = $field_total;
            let scrollPos = $window.scrollTop();
            let header_height = $header.height() + 60;
            let elementPos = $form_fields.offset().top - header_height;
            let bottom_pos = $form_fields.height() - form_field_total.height();

            if (scrollPos - elementPos >= bottom_pos) {
                form_field_total.css('top', bottom_pos);
            } else if (scrollPos >= elementPos) {
                form_field_total.css('top', scrollPos - elementPos);
            } else {
                form_field_total.css('top', 0);
            }
        } else {
            $field_total.css('top', 0);
        }
    });
}

$search.on('submit', () => {
    if (new URLSearchParams(window.location.search).toString() !== new URLSearchParams($search.serialize()).toString()) {
        $search.append(
            '<div class="spinner-overlay">' +
            '<div class="spinner-overlay_spinner">' +
            '<div class="overlay-bounce"></div>' +
            '<div class="overlay-bounce-2"></div>' +
            '<div class="overlay-bounce-3"></div>' +
            '</div>' +
            '</div>',
        );
    }
});
